
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { HttpHeaders } from '@angular/common/http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { Realtime } from 'ably';
import { Subject, BehaviorSubject } from 'rxjs';

declare const FB: any;

@Injectable()
export class UserService {


    private languageSubject = new BehaviorSubject<string>('en'); 
    language$ = this.languageSubject.asObservable();
    setLanguage(language: string): void {
      this.languageSubject.next(language);
    }
    getLanguage() {
      return this.language$;
    }

    backendUrl: any;
    id: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;
    ablyKey: any;
    constructor(private http: AuthHttp) {

        this.backendUrl = window.location.origin
        if(!environment.production)
            this.backendUrl = environment.url;
        this.backendUrl += "/apis"

        this.id = environment.appid;
        this.secret = environment.secret;
        this.ablyKey = environment.ablyKey;
    }

    // Observable string sources
    private componentMethodCallSource = new Subject<any>();

    // Observable string streams
    componentMethodCalled$ = this.componentMethodCallSource.asObservable();

    // Service message commands
    callComponentMethod(data, status = false) {
        this.componentMethodCallSource.next(data);
    }


    getClient(_appUrl?: string) {
        return new Realtime(this.ablyKey);
    }

    getChannel(ably: Realtime) {
        return ably.channels.get('online-ordering');
    }

    fbLogin(backendUrl: any, id: any, locale: any, utm_source: any, utm_campaign: any, http_referrer: any) {
        FB.init({
            appId: id,
            status: false, // the SDK will attempt to get info about the current user immediately after init
            cookie: true,  // enable cookies to allow the server to access the session
            xfbml: true,  // With xfbml set to true, the SDK will parse your page's DOM to find and initialize //any social plugins that have been added using XFBML
            version: 'v8.0' // use graph api version 2.5
        });
        return new Promise((resolve, reject) => {
             FB.login(result => {
                //console.log("login result------",result);
                if (result.authResponse) {
                    this.TOKEN = localStorage.getItem('login_token')
                    this.headers = new Headers({ 'Content-Type': 'application/json' });
                    this.headers.append('Authorization', this.TOKEN)
                    this.options = new RequestOptions({ headers: this.headers });
                    console.log("check options here", this.options)
                    locale = locale + '' + '_US'
                    console.log(locale)
                    let partner_id = "";
                    let whitelabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'))
                    if (whitelabelSetting && whitelabelSetting.dashboard) {
                        partner_id = whitelabelSetting.partner_id
                    }
                    return this.http.post(this.backendUrl + '/api/v1/auth/facebook', { access_token: result.authResponse.accessToken, user_locale: locale, utm_source: utm_source, utm_campaign: utm_campaign, http_referrer: http_referrer, owner_id: partner_id }, this.options)
                        .toPromise()
                        .then(response => {
                            console.log("cchejkcnjcjncjcjdnc response................", response.status, response)
                            let userData = response.json();
                            //console.log('here is data', userData);
                            var token = response.headers.get('x-auth-token');
                            if (token) {
                                this.http.post(this.backendUrl + '/exchange_token', JSON.stringify({ 'app_id': this.id, 'access_token': result.authResponse.accessToken, 'secret': this.secret }), this.options)
                                    .map(data => data.json())
                                    .subscribe(data => {
                                        let res = data.response;
                                        let res1 = JSON.parse(res);
                                        localStorage.setItem('access_token', res1.access_token);
                                        localStorage.setItem('id_token', token);
                                        localStorage.removeItem('login_token');
                                        localStorage.setItem('currentUser', JSON.stringify(response.json()));
                                        resolve(response.json());
                                    });
                            }


                        })
                        .catch((e) => {
                            console.log("chcknhbybyyyyyyyyyyyyyyyyyyyyyyyyyy", e.json())
                            reject(e.json());
                        })
                } else {
                    reject();
                }
            }, { scope: 'email,pages_messaging,read_page_mailboxes,pages_show_list,pages_manage_ads,pages_manage_metadata,pages_read_engagement,pages_read_user_content,pages_manage_posts,instagram_basic,instagram_manage_messages,instagram_manage_comments' });
            //manage_pages, publish_pages. deprecated permissions
        });
    }

    isLoggedIn(id) {
        return new Promise((resolve, reject) => {
            return this.http.get(this.backendUrl + '/api/v1/auth/me?id=' + id).toPromise().then(response => {
                resolve(response.json());
            }).catch(() => reject(false));
        });
    }

    getAll() {
        return this.http.get('/api/users', this.jwt_new()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt_new()).map((response: Response) => response.json());
    }

    create(user: User) {
        return this.http.post('/api/users', user, this.jwt_new()).map((response: Response) => response.json());
    }

    update(user: User) {
        return this.http.put('/api/users/' + user.id, user, this.jwt_new()).map((response: Response) => response.json());
    }

    delete(id: number) {
        return this.http.delete('/api/users/' + id, this.jwt_new()).map((response: Response) => response.json());
    }
    upload(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/upload', formData, this.jwt()).map((response: Response) => response.json());
    }
    insert(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_new', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    delete_new(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/delete', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    delete_pos_mapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/delete_pos_mapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    upload_sep_promotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/upload_sep_promotion', formData, this.jwt()).map((response: Response) => response.json());
    }
    upload_image_url(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/upload_image_url', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    update_promotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/offer-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    insert_promotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/offer-create', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    insert_welcome_msg(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_welcome_msg', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getFacturaProductCodes(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/factura/v1/getProductCode', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    insert_addnewdeliverymenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_addnewdeliverymenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_menucategory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_menucategory', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_menu_item(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_menu_item', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    fileWrite(backendurl: any, formdata: any) {
        return this.http.post(this.backendUrl + "/filewrite", formdata, this.jwt_new()).map((response: Response) => response.json());
    }

    getbranchcode(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getbranchcode', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_quick_reply(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_quick_reply', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_invoice_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_invoice_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    print_invoice(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/print_invoice', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getSenderId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getSenderId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    fb_messages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/fb_messages', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getActiveOrder(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_active_order', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getReasonList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_reason_list', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getReasonListSec(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_reason_list_sec', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    cancelOrder(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/cancel_order', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    sendMessage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/send_message_user', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRewardRules(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardRules', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateRewardRuleStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRewardRuleStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteRewardRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteRewardRule', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    searchByRuleType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchByRuleType', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRewardRuleById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardRuleById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveRewardRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveRewardRule', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getLoyaltyPromotionByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/promotions-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getdata_loyaltysett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_loyaltysett', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_othersettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_othersettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    update_loyalty_setting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_loyalty_setting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_othersettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_othersettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getRedeemptionRules(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/redemption-rule-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getRedeemptionRulesDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/redemption-rule-details', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateRedemptionRuleStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/redemption-rule-statusupdate', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    deleteRedemptionRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteRedemptionRule', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    searchByRedeemRuleType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchByRedeemRuleType', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRedemptionRuleById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRedemptionRuleById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveRedemptionRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/redemption-rule-create', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateRedemptionRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/redemption-rule-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getShareablePromition(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getShareablePromition', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getUsername(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUsername', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    savePushPromotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/savePushPromotion', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getTimezoneData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getTimezoneData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getCurrencyData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCurrencyData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    bulk_upload(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/bulk_upload', formData, this.jwt()).map((response: Response) => response.json());
    }
    savebulkPushPromotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/savebulkPushPromotion', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRestDetailsByPageID(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestDetailsByPageID', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    subscribedApps(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/subscribedApps', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    fbWebviewSettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/fbWebviewSettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveWizardData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveWizardData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveSubUnsubLog(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveSubUnsubLog', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getUserProfiles(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUserProfiles', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getUserProfileData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUserProfileData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveFeedbackform(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveFeedbackform', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getFeedback(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getFeedback', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    countRestaurentId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/countRestaurentId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBranchesForTbReservation(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForTbReservation', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getTbReservationList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getTbReservationList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteTbReservation(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteTbReservation', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getTrByName(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getTrByName', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchAndRefreshTR(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchAndRefreshTR', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getadminteam(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getadminteam', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    changestatus_of_agent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/changestatus_of_agent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addupdateadminteam(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addupdateadminteam', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    editagent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/editagent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteagent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteagent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getpersistentmenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getpersistentmenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getpostbackbtn(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getpostbackbtn', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addupdatePermenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addupdatePermenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deletePermenu(backendUrl: any, formData: any) {
        return this.http.delete(backendUrl + '/deletePermenu/' + formData, new RequestOptions({
            headers: new Headers({ 'Content-Type': 'application/json' })
        })).map((response: Response) => response.json());
    }

    setpersistentmenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/setpersistentmenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRestaurantDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRestaurantDetailsByUserId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantDetailsByUserId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    disconnectPage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/disconnectPage', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateRestaurantData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRestaurantData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveSubcriptionData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveSubcriptionData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    connectPage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/connectPage', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBranchDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteBranchById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteBranchById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateBranchDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateBranchDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    searchBranchData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchBranchData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveScanCode(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveScanCode', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBraanchDetailById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBraanchDetailById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getWifiDetailByBranchId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getWifiDetailByBranchId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBusinessHourByBranchId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBusinessHourByBranchId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateOrSaveBranchData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/updateOrSaveBranchData', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateOrSaveAliaseData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrSaveAliaseData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateOrCreateBusinessHours(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrCreateBusinessHours', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateOrCreateWifiData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrCreateWifiData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPromotiomByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPromotiomByRestId', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPromotions(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/promotions-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getDeliveryPartnerList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-mapping-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getDeliveryPartnerAccountList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-account-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getDeliveryPartnerAccountAdd(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-account-add', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getDeliveryPartnerMappingAdd(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-mapping-add', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getDeliveryPartnerAccountUpdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-account-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getDeliveryPartnerMappingUpdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/partners-mapping-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    deletePromotionById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/offer-remove', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updatePromotionStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/offer-statusupdate', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    searchPromotionByName(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchPromotionByName', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    // getPromotionById(backendUrl: any, formData: any) {
    //     return this.http.post(this.backendUrl + '/getPromotionById', formData, this.jwt_new()).map((response: Response) => response.json());
    // }

    getPromotionById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/offer-details', formData, this.getHeaders()).map((response: Response) => response.json());
    }



    getBranchDetailsByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchDetailsByRestId', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getHolisticsToken(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getHolisticsToken', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getMenuByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMenuByRestId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getMenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteMenuByMenuId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteMenuByMenuId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insertMenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertMenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    send_mail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/send_mail', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_addtrsetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_addtrsetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchAndTRData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchAndTRData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchwiseList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchwiseList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchTRbyBrnachName(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchTRbyBrnachName', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateTRStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateTRStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteTRById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteTRById', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateOrCreateTRGenSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrCreateTRGenSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchwiseListById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchwiseListById', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateBookingHours(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateBookingHours', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateTRPhoneValid(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateTRPhoneValid', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateTRPhoneHistory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateTRPhoneHistory', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getQuickReplyData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getQuickReplyData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBotLanguage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBotLanguage', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getQuickReply(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getQuickReply', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getAllMsgUserDefinedByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getAllMsgUserDefinedByRestId', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getMsgUserDefinedByPayload(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMsgUserDefinedByPayload', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getQRDefaultByLang(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getQRDefaultByLang', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getCBFdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCBFdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getQRByMenutype(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getQRByMenutype', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getLoyaltySetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getLoyaltySetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getOrderTyprSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getOrderTyprSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRestaurantSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    broadcast_bulk_upload(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/broadcast_bulk_upload', formData, this.jwt()).map((response: Response) => response.json());
    }

    getKeyworddetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getKeyworddetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteKeywordById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteKeywordById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateKeywordStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateKeywordStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateKeyword_rule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateKeyword_rule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertKeyword_rule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertKeyword_rule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchKeywordByName(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchKeywordByName', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchKeyruleByid(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchKeyruleByid', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    selectPromotions(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/selectPromotions', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    selectQuickreply(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/selectQuickreply', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getEventReservationList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getEventReservationList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteEventReservation(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteEventReservation', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchByEventtitle(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchByEventtitle', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchAndRefreshEvent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchAndRefreshEvent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateComment_rule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateComment_rule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertComment_rule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertComment_rule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getCommentdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCommentdetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteCommentById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteCommentById', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateCommentStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateCommentStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchPOSTID(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchPOSTID', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchCommentByid(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchCommentByid', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    validatePostrule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/validatePostrule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getAllOrder(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_all_order', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    
    getOrderDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/get-order-details', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getOrderItemDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_order_item_detail', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateOrCreateDeliveryArea(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrCreateDeliveryArea', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getDeliveryAreaByBranchId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getDeliveryAreaByBranchId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getNavMenuByRoleId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_nav_menu_by_role_id', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUserPermissionByRouteName(backendUrl: any, formData: any) {
        console.log("222222222222222222")
        return this.http.post(this.backendUrl + '/getUser_permission_by_route_name', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getSubMenuByRouteId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getSubMenuByRouteId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPrmotionTypedata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPrmotionTypedata', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPrmotionAllType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPrmotionAllType', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getCampaignIdByRoleId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCampaignIdByRoleId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBranchDetailsByRestIdPro(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchDetailsByRestIdPro', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBranchIdsByRestId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchIdsByRestId', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getFollowupMsg(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getFollowupMsg', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getOrderModifierDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_order_modifier_detail', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getDeliveryMsg(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_delivery_msg', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPromotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPromotion', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    promotionReport(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/promotionReport', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    searchPromotionReport(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchPromotionReport', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getSource_type(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getSource_type', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    get_Loyalty_Report(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getLoyaltyreport', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    loyalty_Detailedreport(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyalty_Detailedreport', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    default_flow(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/default_flow', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateDefaultflow(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateDefaultflow', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getEventList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/geteventlist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateEventStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateeventstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteEvent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteevent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchingInEvent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchingInEvent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    tablereservationFloor(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/tablereservationFloor', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    createUPEvent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/createUPEvent', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getEventById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getEventById', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesForOrderSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForOrderSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesWiseOrderSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesWiseOrderSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateOrderStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOrderStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getDeliveryPartner(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getDeliveryPartner', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    saveOrderSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveOrderSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    saveOrderSettingDeliveryArea(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveOrderSettingDeliveryArea', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteOrderSettingDeliveryArea(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteOrderSettingDeliveryArea', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getBranchesWisePaymentSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesWisePaymentSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatePaymentStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatePaymentStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPaymentGetway(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPaymentGetway', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesWisePaymentGetwaySetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesWisePaymentGetwaySetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatePaymentDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatePaymentDetail', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatePaymentDetailPP(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatePaymentDetailPP', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesWisePaymentGetwaySettingPP(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesWisePaymentGetwaySettingPP', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesWisePaymentGetwaySettingCash(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesWisePaymentGetwaySettingCash', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getTimezoneCountrycode(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getTimezoneCountrycode', this.jwt_new()).map(
            (response: Response) => response.json());
    }
    getPosDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPosDetail', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPosPromoMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/pos-promo-mapping', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getPosPromoById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPosPromoById', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getRestaurantUsers(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantUsers', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    changeUserStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/changeUserStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteUser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteUser', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    editUser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/editUser', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getRewardPlan(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardPlan', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUsernameAndRewardPlan(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUsernameAndRewardPlan', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateRestaurantUser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRestaurantUser', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    fb_messages_add_points(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/fb_messages_add_points', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_emaillisting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_emaillisting', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchBranchData_feedlist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchBranchData_feedlist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateListingDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateListingDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteBranchByEmailListId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteBranchByEmailListId', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_feedbackemailsett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_feedbackemailsett', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_feedbackemailsett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_feedbackemailsett', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addbranch_feedbackemailsett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addbranch_feedbackemailsett', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_feedbackemailsett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_feedbackemailsett', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateBranchData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_branch_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_menumaster(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_menumaster', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateMenuMasterDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateMenuMasterDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteBranchByMenuMasterList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteBranchByMenuMasterList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchBranchData_Menumasterlist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchBranchData_Menumasterlist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    menulistdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menulistdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateandselectlist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateandselectlist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_menumasterlist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_menumasterlist', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getdata_menulistbyname(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_menulistbyname', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_categorybyname(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_categorybyname', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteMenuImageByMenuId(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteMenuImageByMenuId', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_addeditmenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_addeditmenu', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatesamemenudetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatesamemenudetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addeditmenucategorybylist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addeditmenucategorybylist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addmenucategorybylist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addmenucategorybylist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_menurecord(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_menurecord', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    editmenufilelist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/editmenufilelist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUserData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_user_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    addUserpoints(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/add-user-points', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getTransactionData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_transaction_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_menuresult(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_menuresult', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    catmenuon(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/catmenuon', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    categorybynamedata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/categorybynamedata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatecatnamedetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecatnamedetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_resdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_resdetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatecatgries_menu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecatgries_menu', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatesame_menu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatesame_menu', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatecatflagoff(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecatflagoff', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteBranchByResMenuList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteBranchByResMenuList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_searchlistbyname(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_searchlistbyname', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_searchlistbysinglename(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_searchlistbysinglename', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_searchbranchbyname(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_searchbranchbyname', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdatamenuid(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdatamenuid', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatebranchflagon(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatebranchflagon', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatebranchflagoff(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatebranchflagoff', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_facturarule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_facturarule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchFacturaData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchFacturaData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatefacturastatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatefacturastatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    facturaeditlistdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/facturaeditlistdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    facturaselectandupdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/facturaselectandupdate', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_facturarulelist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_facturarulelist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_menubranchesresult(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_menubranchesresult', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    pickdropdownwizard(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pickdropdownwizard', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_emailmaster(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getdata_emailmaster', this.jwt_new()).map((response: Response) => response.json());
    }
    searchEmailData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchEmailData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateemailstatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateemailstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteEmailMasterList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteEmailMasterList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    emailtemplateeditlistdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/emailtemplateeditlistdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    emailmasterselectandupdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/emailmasterselectandupdate', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_emailtemplatelist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_emailtemplatelist', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    adddropdownonwizard(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/adddropdownonwizard', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getLoyaltyPlans(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyplans/getPlan/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUsersWithoutRewardPlan(formData: any) {
        return this.http.get(this.backendUrl + '/loyaltyplans/unassignRewardPlanUsers/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateUserRewardPlan(backendUrl: any, formData: any) {
        return this.http.put(this.backendUrl + '/loyaltyplans/assignRewardPlanToUsers', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    changestatusLoyaltyPlans(backendUrl: any, formData: any) {
        return this.http.put(this.backendUrl + '/loyaltyplans/changeStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    mappingLoyaltyPlans(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyplans/addEditPlanMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getFacturaReportData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_factura_report', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getTranscationSummary(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getTranscationSummary', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesForTranscationSummary(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForTranscationSummary', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchdropdowndata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchdropdowndata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    searchTS(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/searchTS', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    downloadFactura(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/download_factura_forPanel', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getLoyaltyrules(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/getrules/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    changestatus_of_rule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/changestatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteLoyaltyRule(backendUrl: any, formData: any) {
        return this.http.delete(this.backendUrl + '/loyaltyrules/delete/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPromoForLoyaltyrules(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/getPromoForLoyaltyrules/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    saveLoyaltyRewardRule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/add-edit-loyalty-rule', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    editLoyaltyRules(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/edit/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    checkRulename(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/check/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notificationtemplaterenderdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notificationtemplaterenderdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatenotificationtemplatestatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatenotificationtemplatestatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteNotificationMasterList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteNotificationMasterList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notificationtemplateeditlistdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notificationtemplateeditlistdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notificationtempselectandupdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notificationtempselectandupdate', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notificationtemplatemasterdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notificationtemplatemasterdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_notificationtemplatelist(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_notificationtemplatelist', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRfcdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/rfcdetails/getrfcdetails/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    changestatus_of_rfc(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/rfcdetails/changestatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteRfcDetails(backendUrl: any, formData: any) {
        return this.http.delete(backendUrl + '/rfcdetails/delete/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    upload_files(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/upload_files', formData, this.jwt()).map((response: Response) => response.json());
    }
    saveRFCDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/rfcdetails/addEdit', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    editRFCDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/rfcdetails/edit/' + formData, this.jwt_new()).map((response: Response) => response.json());
    }
    manage_agent_branchdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/manage_agent_branchdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notificationn_type_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notificationn_type_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUsernamesearchdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUsernamesearchdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getUsernameshowdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getUsernameshowdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getadminteamrenderdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getadminteamrenderdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notification_type_data_render(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notification_type_data_render', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notification_dropdown(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notification_dropdown', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertrestaurantdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertrestaurantdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    notification_editdatarender(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/notification_editdatarender', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_restaurant_data_agent(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_restaurant_data_agent', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getsmtpdetails(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getsmtpdetails', this.jwt_new()).map((response: Response) => response.json());
    }
    updateSMTPstatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateSMTPstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteSMTPMasterList(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteSMTPMasterList', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    editsmtpdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/editsmtpdetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    smtptemplateselectandupdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/smtptemplateselectandupdate', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_smtptemplatedetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_smtptemplatedetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    countis_default(backendUrl: any) {
        return this.http.get(this.backendUrl + '/countis_default', this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_rulemapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_rulemapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getdata_ruledata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getdata_ruledata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_mappingrule(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_mappingrule', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_getruledata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_getruledata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_global_factura_rfc_details(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_global_factura_rfc_details', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_rfcdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_rfcdetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_rfcdetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_rfcdetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_facturamessages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_facturamessages', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_facturamessages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_facturamessages', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_facturamessages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_facturamessages', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getGlobalFacturaSettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_global_factura_settings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getGlobalFacturaDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_global_factura', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    saveGlobalFacturaDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/saveGlobalFacturaDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_rfcVslocationmapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_rfcVslocationmapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteRFCMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteRFCMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateRFCstatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRFCstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateRFCmessenger_link_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRFCmessenger_link_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_mapnewbranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_mapnewbranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_rfcdatadropdown(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_rfcdatadropdown', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_smtpdatadropdown(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_smtpdatadropdown', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_emailsuccessandfaildatadropdown(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_emailsuccessandfaildatadropdown', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_rfcVslocationmapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_rfcVslocationmapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    rfcmappingselectandupdate(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/rfcmappingselectandupdate', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesForRFCMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForRFCMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_RFCMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_RFCMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_possettingsdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_possettingsdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_pos_settings_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_pos_settings_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_rest_key(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_rest_key', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getSubscribePage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getSubscribePage', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_posVsbranchMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_posVsbranchMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_mapposbranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_mapposbranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_pos_type_data_render(backendUrl: any) {
        return this.http.get(this.backendUrl + '/get_pos_type_data_render', this.jwt_new()).map((response: Response) => response.json());
    }
    edit_posVsbranchMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_posVsbranchMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_poslocationmappingdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_poslocationmappingdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesForPOSmapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForPOSmapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    generatehashkey(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/generatehashkey', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_POSMapping(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_POSMapping', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_POSCryptoSettingrenderdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_POSCryptoSettingrenderdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatecryptostatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecryptostatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_cryptomapnewbranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_cryptomapnewbranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_defaultcurrencydropdown(backendUrl: any) {
        return this.http.get(this.backendUrl + '/get_defaultcurrencydropdown', this.jwt_new()).map((response: Response) => response.json());
    }
    get_defaultlabeldropdown(backendUrl: any) {
        return this.http.get(this.backendUrl + '/get_defaultlabeldropdown', this.jwt_new()).map((response: Response) => response.json());
    }
    edit_POSCryptoSettingrenderdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_POSCryptoSettingrenderdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_cryptosettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_cryptosettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchesForCryptoSettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchesForCryptoSettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_CryptoSettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_CryptoSettings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getcryptocurrencylogorenderdata(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getcryptocurrencylogorenderdata', this.jwt_new()).map((response: Response) => response.json());
    }
    updatecryptocurrencylogostatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecryptocurrencylogostatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_cryptosettingslogodata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_cryptosettingslogodata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    UpdateCryptoCurrencyLogoData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/UpdateCryptoCurrencyLogoData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_CryptoCurrencyLogo(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_CryptoCurrencyLogo', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_restaurant_name(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_restaurant_name', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_json_table_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_json_table_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_json_records(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_json_records', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_json_records(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_json_records', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_tr_restaurant_settings_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_tr_restaurant_settings_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_json_table_match_record(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_json_table_match_record', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_json_invalid_restaurant(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_json_invalid_restaurant', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getcryptocurrencylabelrenderdata(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getcryptocurrencylabelrenderdata', this.jwt_new()).map((response: Response) => response.json());
    }
    updatecryptocurrencylabelstatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatecryptocurrencylabelstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_cryptolabeldata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_cryptolabeldata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    UpdateCryptoCurrencyLabelData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/UpdateCryptoCurrencyLabelData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_CryptoCurrencyLabel(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_CryptoCurrencyLabel', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPOSTyperenderdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPOSTyperenderdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatePOSTypestatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatePOSTypestatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_POSTypeData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_POSTypeData', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    UpdatePOSType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/UpdatePOSType', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertPOSType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertPOSType', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getPOS_Payment_Method_data(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getPOS_Payment_Method_data', this.jwt_new()).map((response: Response) => response.json());
    }
    update_POS_paymentmethod_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_POS_paymentmethod_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_pos_paymentmethod(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_pos_paymentmethod', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_POS_paymentmethod(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_POS_paymentmethod', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_POS_paymentmethod(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_POS_paymentmethod', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateothersettingsvisittime(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateothersettingsvisittime', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getACL_roles_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getACL_roles_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateACL_roles_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateACL_roles_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_ACL_roles(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_ACL_roles', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    UpdateACL_roles_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/UpdateACL_roles_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insertdata_ACL_roles(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertdata_ACL_roles', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_campaignmaster_data(backendUrl: any) {
        return this.http.get(this.backendUrl + '/get_campaignmaster_data', this.jwt_new()).map((response: Response) => response.json());
    }
    getACL_manage_users_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getACL_manage_users_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateACL_manageusers_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateACL_manageusers_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_ACLmanageusers(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_ACLmanageusers', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_timezone_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_timezone_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_define_new_access(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_define_new_access', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    deleteUserAccess(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteUserAccess', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_location_record(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_location_record', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_acl_role_name(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_acl_role_name', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_restaurant_name_acl(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_restaurant_name_acl', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_branches_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_branches_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_newaccess_rest_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_newaccess_rest_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_ACL_AccessUser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_ACL_AccessUser', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_ACL_AccessUser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_ACL_AccessUser', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_ACL_manageusers(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_ACL_manageusers', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_ACL_manageusers(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_ACL_manageusers', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    get_noresult_restaurant_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_noresult_restaurant_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updatemastercampaignstatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatemastercampaignstatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    updateOnlineorder_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateOnlineorder_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    edit_campaignmaster_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/edit_campaignmaster_data', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_Campaign_Master(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_Campaign_Master', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    insert_Campaign_Master(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_Campaign_Master', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBranchSettingsByBranchid(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchSettingsByBranchid', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    update_branchwise_settings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_branchwise_settings', formData, this.jwt_new()).map((response: Response) => response.json());
    }


    // Payment Gateway Services
    addPaymentGateway(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/add_payment_gateway', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPaymentGateways(backendUrl: any) {
        return this.http.get(this.backendUrl + '/get_payment_gateways', this.jwt_new()).map((response: Response) => response.json());
    }


    getPaymentGateway(backendUrl: any, id: any) {
        return this.http.post(this.backendUrl + '/get_payment_gateway', id, this.jwt_new()).map((response: Response) => response.json());
    }


    updatePaymentGateway(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/Update_payment_gateway', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updatePaymentGatewayStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_payment_gateway_status', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    // Payment Gateway Services end

    get_specificpromotions_restdata(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_specificpromotions_restdata', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    insert_persistmentmenubyGeneralSett(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insert_persistmentmenubyGeneralSett', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    // insert_menu_item_modifier(backendUrl: any, formData: any) {
    //     return this.http.post(this.backendUrl + '/insert_menu_item_modifier', formData, this.jwt_new()).map((response: Response) => response.json());
    // }

    insert_menu_item_modifier(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/insert-menu-item-modifier', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getallQuickReplyConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_all_QuickReply_Configuration', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getAllPromotionType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_all_Promotion_Type', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    AddMenuItemsById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_menuitems_by_add_new', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    GetCallingCode(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_calling_code', formData, this.jwt_new()).map((response: Response) => response.json());
    }


    getMarketPlaceSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/getMarketPlaceSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updateMarketPlaceSetting(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/updateMarketPlaceSetting', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    GetCurrencyFormatter(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_currency_formatter', formData, this.jwt_new()).map(response => response.json());
    }

    GetPostypeDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/GetPostypeDetails', formData, this.jwt_new()).map(response => response.json());
    }
    GetMstPosTypeData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMstPosTypeData', this.jwt_new()).map(response => response.json());
    }


    getPosCategory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_category', formData, this.jwt_new()).map(response => response.json());
    }

    getPosProduct(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_products', formData, this.jwt_new()).map(response => response.json());
    }


    pos_products_type(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_products_type', formData, this.jwt_new()).map(response => response.json());
    }

    getPosMappingBranchDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPosMappingBranchDetails', formData, this.jwt_new()).map(response => response.json());
    }

    getPosModifierCat(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_category_modifier', formData, this.jwt_new()).map(response => response.json());
    }
    getPosPackage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_package', formData, this.jwt_new()).map(response => response.json());
    }

    getPosModifieritems(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_modifier_items', formData, this.jwt_new()).map(response => response.json());
    }

    getPosModifierMappingitems(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/pos_modifier_mapping_items', formData, this.jwt_new()).map(response => response.json());
    }

    GetDisplayKeys(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_display_keys', formData, this.jwt_new()).map(response => response.json());
    }

    GetDisplayKeysMixBranch(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_display_keys_mix_branch', formData, this.jwt_new()).map(response => response.json());
    }

    GetRouteIdByRouteName(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_route_id_by_route_name', formData, this.jwt_new()).map(response => response.json());
    }

    SendOrderIdShowStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/SendOrderIdShowStatus', formData, this.jwt_new()).map(response => response.json());
    }

    getfacturabranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getfacturabranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }


    getMenuCategoryAndItems(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_menu_category_and_items', formData, this.jwt_new()).map(response => response.json());
    }

    getAllRestaurantPackage(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_all_restaurant_package', formData, this.jwt_new()).map(response => response.json());
    }



    getModifierCategoriesByRestaurant(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_restaurant_modifier_categories', formData, this.jwt_new()).map(response => response.json());
    }

    getModifierItemsByRestaurant(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_restaurant_modifier_items', formData, this.jwt_new()).map(response => response.json());
    }

    pauseOrder(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/pause_order', formData, this.jwt_new()).map(response => response.json());
    }

    getRestauranttz(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/branches/get_restaurant_tz', formData, this.jwt_new()).map(response => response.json());
    }


    getCountryCode(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCountryCode', formData, this.jwt_new()).map(response => response.json());
    }


    updateRestaurantUserEmail(formData: any) {
        return this.http.post(this.backendUrl + '/updateRestaurantUserEmail', formData, this.jwt_new()).map(response => response.json());
    }

    GetAllSystemVariables(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_all_system_variables', formData, this.jwt_new()).map(response => response.json());
    }

    GetOdooPosType(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_odoo_pos_type', formData, this.jwt_new()).map(response => response.json());
    }

    UpdateSystemVariableData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/UpdateSystemVariableData', formData, this.jwt_new()).map(response => response.json());
    }


    getBranchMenuItems(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchMenuItems', formData, this.jwt_new()).map(response => response.json());
    }

    getRestaurantMenuCategory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantMenuModifier', formData, this.jwt_new()).map(response => response.json());
    }

    getMergeConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMergeConfiguration', formData, this.jwt_new()).map(response => response.json());
    }

    updateMergeConfiguration(formData: any) {
        return this.http.post(this.backendUrl + '/updateMergeConfiguration', formData, this.jwt_new()).map(response => response.json());
    }


    getBranchMenuIModifierCategory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getBranchMenuIModifierCategory', formData, this.jwt_new()).map(response => response.json());
    }

    updateBranchMenuIModifierCategoryPos(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateBranchMenuIModifierCategoryPos', formData, this.jwt_new()).map(response => response.json());
    }




    updateBranchMenuItemStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateBranchMenuItemStatus', formData, this.jwt_new()).map(response => response.json());
    }

    composerchange(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/composerchange', formData, this.jwt_new()).map(response => response.json());
    }

    getallSearchOrderHistory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getallSearchOrderHistory', formData, this.jwt_new()).map(response => response.json());
    }
    orderSalesData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/order_sales_report', formData, this.jwt_new()).map(response => response.json());
    }


    getmenupackages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/getdata', formData, this.jwt_new()).map(response => response.json());
    }
    getBranhesmp(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/getbranchmp', formData, this.jwt_new()).map(response => response.json());
    }
    updatemenupackages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/updatemenupackages', formData, this.jwt_new()).map(response => response.json());
    }

    deletemenupackages(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/deletemenupackages', formData, this.jwt_new()).map(response => response.json());
    }

    getpackagesData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/getpackagesData', formData, this.jwt_new()).map(response => response.json());
    }

    insertpackagesData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/insertpackagesData', formData, this.jwt_new()).map(response => response.json());
    }

    editpackagesData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/editpackagesData', formData, this.jwt_new()).map(response => response.json());
    }

    swapPackageData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/menupackage/swapPackageData', formData, this.jwt_new()).map(response => response.json());
    }

    getLoyaltyPlanRules(backendUrl: any) {
        return this.http.get(this.backendUrl + '/loyaltyrules/getplanrules/', this.jwt_new()).map(response => response.json());
    }

    getUpgradeDowngradeRules(backendUrl: any, id: any) {
        return this.http.get(this.backendUrl + `/loyaltyrules/getupgradedowngrade/${id}`, this.jwt_new()).map(response => response.json());
    }

    AddUpdateTableUserConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/loyaltyrules/addupdateloyaltyplans', formData, this.jwt_new()).map(response => response.json());
    }

    GetWidgetSettingsData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/get_widget_settings', formData, this.jwt_new()).map(response => response.json());
    }

    updateWidgetSettingsData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/update_widget_settings', formData, this.jwt_new()).map(response => response.json());
    }

    getInvoiceDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getInvoiceDetails', formData, this.jwt_new()).map(response => response.json());
    }

    getPosPromotion(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPosPromotion', formData, this.jwt_new()).map(response => response.json());
    }

    processInvoice(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/facturaorder-filter', formData, this.jwt_new()).map(response => response.json());
    }

    confirmedProcessInvoice(backendUrl: any, formData: any) {
        return this.http.put(this.backendUrl + '/confirmedProcessInvoice', formData, this.jwt_new()).map(response => response.json());
    }

    removeInprocessInvoice(backendUrl: any, formData: any) {
        return this.http.delete(this.backendUrl + '/removeInprocessInvoice?' + formData, this.jwt_new()).map(response => response.json());
    }

    // Async Factura Processing APIs
    createFacturaRequest(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/factura/request-create', formData, this.jwt_new()).map(response => response.json());
    }

    getFacturaRequestStatus(backendUrl: any, jobId: any, restaurantId: any) {
        return this.http.get(this.backendUrl + '/factura/request-status-get?job_id=' + jobId + '&restaurant_id=' + restaurantId, this.jwt_new()).map(response => response.json());
    }

    getActiveFacturaRequest(backendUrl: any, branchId: any, restaurantId: any) {
        return this.http.get(this.backendUrl + '/factura/get-active-request?branch_id=' + branchId + '&restaurant_id=' + restaurantId, this.jwt_new()).map(response => response.json());
    }

    updateThemeSettingsData(formData: any) {
        return this.http.post(this.backendUrl + '/update_theme_settings', formData, this.jwt_new()).map(response => response.json());
    }

    getmonitoringorderdata(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getmonitoringorderdata', this.jwt_new()).map(response => response.json());
    }

    resetActivationKeyByRest(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/resetActivationKeyByRest', formData, this.jwt_new()).map(response => response.json());
    }

    insertDataMonitoringLog(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertDataMonitoringLog', formData, this.jwt_new()).map(response => response.json());
    }
    getInvoiceprocBranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getInvoiceprocBranches', formData, this.jwt_new()).map(response => response.json());
    }

    getOrderManagerlog(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getOrderManagerlog', formData, this.jwt_new()).map(response => response.json());
    }

    getLastLoginTime(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getLastLoginTime', formData, this.jwt_new()).map(response => response.json());
    }

    getRestaurantThemeSettings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantData', formData, this.jwt_new()).map(response => response.json());
    }
    menupublish(formdata: any) {
        return this.http.post(this.backendUrl + '/menupublish', formdata, this.jwt_new()).map(response => response.json());
    }

    get3rdpartyBranchMapping(formdata: any) {
        return this.http.post(this.backendUrl + '/get3rdpartyBranchMapping', formdata, this.jwt_new()).map(response => response.json());
    }

    proceedData(formdata: any) {
        return this.http.post(this.backendUrl + '/proceedData', formdata, this.jwt_new()).map(response => response.json());
    }

    generate_publish(formdata: any) {
        return this.http.post(this.backendUrl + '/generate_publish', formdata, this.jwt_new()).map(response => response.json());
    }
    getallRestaurantManagerNotificationData(backendUrl: any) {
        return this.http.get(this.backendUrl + '/getallRestaurantManagerNotificationData', this.jwt_new()).map(response => response.json());
    }

    updateRestaurantManagerNotificationData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateRestaurantManagerNotificationData', formData, this.jwt_new()).map(response => response.json());
    }

    deleteRestaurantManagerNotificationData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteRestaurantManagerNotificationData', formData, this.jwt_new()).map(response => response.json());
    }

    insertUpdateRestaurantManagerNotificationData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/insertUpdateRestaurantManagerNotificationData', formData, this.jwt_new()).map(response => response.json());
    }
    getUserRoleAndAcl(formData: any) {
        return this.http.post(this.backendUrl + '/getUserRoleAndAcl', formData, this.jwt_new()).map(response => response.json());
    }
    getInvoiceprint(formData: any) {
        return this.http.post(this.backendUrl + '/getInvoiceprint', formData, this.jwt_new()).map(response => response.json());
    }

    //Store Management

    getRestaurantSettingData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantSettingData', formData, this.jwt_new()).map(response => response.json());
    }

    getStoreManagementData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getStoreManagementData', formData, this.jwt_new()).map(response => response.json());
    }

    uploadRappiMenu(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/rappi-uploadMenu', formData, this.getHeaders()).map(response => response.json());
    }

    updateManageStoreStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updateManageStoreStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getManageStoreMapBranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getManageStoreMapBranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getManageStoreDataById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getManageStoreDataById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getStoreMenuUseData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getStoreMenuUseData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    addUpdateStoreManagement(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/add-update-store', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    //POS Configuration

    getPOSConfigurationData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPOSConfigurationData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPosConfigurationMapBranches(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPosConfigurationMapBranches', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    updatePosConfigurationStatus(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/updatePosConfigurationStatus', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deletePOSConfigurationListing(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deletePOSConfigurationListing', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPOSConfigurationDataById(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPOSConfigurationDataById', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPOSConfigurationProducts(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPOSConfigurationProducts', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPOSConfigurationPullMenuJob(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/pos/softest-pullmenu', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    odooPullMenuJob(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/odoo-getmenu', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    menuDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/getMenu-Details', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    addUpdatePOSConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addUpdatePOSConfiguration', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getMstSettingsPOSConfiguration(backendUrl: any, posId: any) {
        return this.http.get(this.backendUrl + `/getMstSettingsPOSConfiguration/${posId}`, this.jwt_new()).map(response => response.json());
    }

    getMstSettingsManageStores(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getMstSettingsManageStores', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    //Item Properties Data

    getCountryWiseItemPropertiesData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getCountryWiseItemPropertiesData', formData, this.jwt_new()).map((response: Response) => response.json());
    }


    //facebook shop Image

    getFBShopDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getFBShopDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getFBShopCatalogHistory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getFBShopCatalogHistory', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getFBShopCatalogSheetData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getFBShopCatalogSheetData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getfbShopCatalogData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/fbshop-catalog', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getRestaurantUsersCSV(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRestaurantUsersCSV', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    //Reward Details Services Start

    getRewardDetailsData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardDetailsData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRewardSpecificPromotionDetails(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardSpecificPromotionDetails', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteRewardDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/deleteRewardDetail', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getRewardDetailByValidity(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getRewardDetailByValidity', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    addRewardDetailsData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/addRewardDetailsData', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    //Reward Details Services End

    getAllOrderHistory(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getAllOrderHistory', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    // POS COnfiguration

    getPOSPaymentMethodsConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/getPOSPaymentMethodsConfiguration', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getPOSConfigurationMizakiPullMenuJob(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/mizaki-getmenu', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    ModifyReferralCode(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/update-referralcode', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    deductUserpoints(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/loyalty/v1/deduct-user-points', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getMizakiPaymentDataPOSConfiguration(backendUrl: any, apiKey: any) {
        return this.http.get(this.backendUrl + `/getMizakiPaymentDataPOSConfiguration/${apiKey}`, this.jwt_new()).map(response => response.json());
    }

    getRedemptionValidCategories(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/menu-category-list', formData, this.getHeaders()).map(response => response.json());
    }

    //Wallet Configuration

    getallRestaurantWalletData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/wallet-list', formData, this.getHeaders()).map(response => response.json());
    }

    deleteWalletData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/wallet-remove', formData, this.getHeaders()).map(response => response.json());
    }

    createWalletData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/wallet-create', formData, this.getHeaders()).map(response => response.json());
    }

    updateWalletData(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/wallet-update', formData, this.getHeaders()).map(response => response.json());
    }

    getWalletConfiguration(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/wallet-transactions', formData, this.getHeaders()).map(response => response.json());
    }

    downloadWalletDataTranscation(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/downloadWalletDataTranscation', formData, this.jwt_new()).map((response: Response) => response.json());
    }

    getMasterData(backendUrl: any) {
        return this.http.post(this.backendUrl + '/rfcdetails/getMasterData', this.jwt_new()).map((response: Response) => response.json());
    }
    whitelabel_partner_check(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/whitelabel-partner-check', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getWebVersions() {
        return this.http.get(`${this.backendUrl}/getWebVersions`, this.getHeaders()).map((response: Response) => response.json())
      }
      generateAuthToken() {
        this.http.get(this.backendUrl + '/generate_token').map((response: Response) => response.json()).subscribe((data: any) => {
          localStorage.setItem('token', data.token);
        });
      }
    dashbaord_filters_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashbaord-filters-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    scheduled_filters_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/scheduled-filters-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    dashbaord_filters_list_facturauser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashbaord-filters-list-facturauser', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    dashboard_tiles_tables_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-tiles-tables-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    dashboard_tiles_tables_data_v1(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-tiles-tables-data-v1', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    dashboard_tiles_tables_data_facturauser(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-tiles-tables-data-facturauser', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_promotion_analytics_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/get-promotion-analytics-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    dashboard_orders_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-orders-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    scheduled_orders_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/scheduled-orders-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    session_analytics(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/session-analytics', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    session_report(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/session-report', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    send_session_email_alert(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/send-session-report', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_restaurant_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/get-restaurant-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    update_restaurant_status(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/update-restaurant-status', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    menu_sequence_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/menu-sequence-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    get_analytic_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/analytics-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    analytic_add(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/analytics-add', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    pos_customer_screen_img_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/image-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    pos_customer_screen_img_add(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/image-add', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    pos_customer_screen_img_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/image-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    pos_customer_screen_img_remove(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/image-remove', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    pos_terminal_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/terminal-settings-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    kiosk_activationkey_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/get-activationkey-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    kiosk_activationkey_add(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/save-activationkey', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    pos_terminal_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/terminal-settings-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    downloadPosProduct(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/onlineorder/pos_product_download', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    getPosProducts(formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get_inventry_details',formData,this.jwt_new()).map((response: Response) => response.json());
    }
    getPosAttributes(temp: any) {
        return this.http.get(temp, this.jwt_new()).map((response: Response) => response.json());
    }

    getposbranch(formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get_inventry_details',formData,this.jwt_new()).map((response: Response) => response.json());
    }

    get_scheduled_OrderDetail(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get_scheduled_order_details', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    alerts_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/alerts-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    alerts_add(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/alerts-add', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    alerts_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/alerts-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    alerttype_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/alerttype-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    status_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/update-status', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    soft_delete(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/softdelete', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getBrandsList(formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/brands-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getFontsList() {
        return this.http.post(this.backendUrl + '/db/common/v1/fonts-list',  this.getHeaders()).map((response: Response) => response.json());
    }

    getSelectedLang() {
        return this.http.post(this.backendUrl + '/updateACL_manageusers_status',  this.getHeaders()).map((response: Response) => response.json());
    }


    updateBrandStatus(formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/update-status', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    
    giftcard_sale_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/giftcard-sale-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    update_restaurant_settings(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/update-restaurant-settings', formData, this.jwt_new()).map((response: Response) => response.json());
    }
    getBlackListArea(formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get_blacklist_area_details', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    saveUpdateBlacklistArea(formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/save_blacklist_area_details', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    deleteBlackListDeliveryArea(formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/delete_blacklist_area_details', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    pricelists(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/pricelists-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_pricelist_data(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get-pricelist-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    pricelist_manage(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/pricelists-manage', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_pos_payment_terminals(backendUrl: any) {
        return this.http.get(this.backendUrl + '/db/pos/v1/get-pos-payment-terminals', this.getHeaders()).map((response: Response) => response.json());
    }
    terminal_make_payment(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/pos/v1/terminal_make_payment', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_terminal_mapping(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/get-pos-terminal-mapping', formData, this.getHeaders()).map((response: Response) => response.json());
    }

   add_edit_terminal_mapping(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/add-edit-terminal-mapping', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    update_email_phone(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/phone-email-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }
        promotion_delete_chk(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/campaign-delete-chk', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getbrand_detail(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/getbrand_detail', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    
    check_online_order_status(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/check-online-order-status', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    dashboard_activity_log(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-activity-log', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    

    dashbaord_customer_report(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/dashboard-customer-report', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    

    generate_mapping_key(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/generate_mapping_key', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    update_approval_request(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/update_approval_request', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    

    chk_approval_request(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/chk_approval_request', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_kiosk_layout(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/get-kiosk-layout', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    add_kiosk_layout(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/add-kiosk-layout', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    kiosk_settings_get(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/kiosk-settings-get', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    kiosk_settings_update(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/kiosk-settings-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    kiosk_terminal_list(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/get-kiosk-terminals', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    kiosk_terminal_update(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/kiosk/v1/update-kiosk-terminals', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    feedback_report(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/analytics/v1/feedback-report', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    signup_report(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/analytics/v1/get-restaurant-users-summary', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    signupdetail_report(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/analytics/v1/get-restaurant-users', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    payment_report(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/analytics/v1/get-sales-report', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    scheduled_orders_cancel(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/scheduled-order-cancel', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    om_presence_history(backendUrl: any,formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/om-presence-history', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_terminal_data(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/get-terminal-data', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    update_default(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/pos/v1/update-is-default', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    clone_modifier(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/common/v1/copy-modifier', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    get_menu_items(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/onlineorder/v1/get-menu-items', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    delete_menu_type(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/delete-menu-type', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    delete_menu_category(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/delete-menu-category', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    add_edit_menu_item(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/add-edit-menu-item', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    add_edit_menu_category(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/add-edit-menu-category', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    add_edit_campaigns(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/add-edit-menu-campaigns', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    
    get_page_by_id(backendUrl: any, formData: any) {
        return this.http.post(this.backendUrl + '/db/rest-details/v1/get-page-by-id', formData, this.getHeaders()).map((response: Response) => response.json());
    }
    
    getMenuCategoriesList(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/menu-category-translations-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getMenuItemsList(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/menu-translations-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getModifierCategoriesList(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/modifier-category-translations-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    getModifierItemsList(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/modifier-item-translations-list', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateMenuCategories(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/menu-category-translations-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateMenuItems(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/menu-translations-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateModifierCategories(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/modifier-category-translations-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    updateModifierItems(formData: any){
        return this.http.post(this.backendUrl + '/db/menu/v1/modifier-item-translations-update', formData, this.getHeaders()).map((response: Response) => response.json());
    }

    // getCountry(){
    //     console.log("checkmm here in country @@@@@@@@@@@@@@@@@@@@@")
    //     return this.http.get(`https://ipapi.co/json/`)
    //   }

    getPosition(): Promise<any> {
        return new Promise((resolve, reject) => {

            navigator.geolocation.getCurrentPosition(resp => {
                resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
            },
                err => {
                    //console.log('dsf', err)
                    reject(err);
                });
        });
    }
    settingCss(settings) {
        settings = JSON.parse(settings)
        if (settings.partner_id == "d783a4fe-f6cb-11ec-b939-0242ac120002") {
            $(document).ready(function () {
                console.log("ready!");
                $("head").append('<link rel="stylesheet" type="text/css" href="../../assets/css/partner1.css">');
            });

        }
    }

    private getHeaders() {
        let headerVal = new Headers({ 'Content-Type': 'application/json' });
        headerVal.append('authorization', environment.authorization_key)
        headerVal.append('uuid', environment.uuid)
        let optionVal = new RequestOptions({ headers: headerVal });
        return optionVal;
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/user.service.ts